export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CLEAR_AUTH_MESSAGES = "CLEAR_AUTH_MESSAGES";

export const CLEAR_STATE = "CLEAR_STATE";

//Auth Message and Message types
export const AUTH_MESSAGE = "AUTH_MESSAGE";
